module.exports = __webpack_public_path__ + "static/media/aboutus-3.81f0f270.png";